import styled from "react-emotion"
import PropTypes from "prop-types"

const WithMargin = styled("div")`
    margin: ${props => props.theme[props.margin || ""]};
    ${props =>
        props.marginRight &&
        `
        margin-right: ${props.theme[props.marginRight]};
    `};
    ${props =>
        props.marginLeft &&
        `
        margin-left: ${props.theme[props.marginLeft]};
    `};
    ${props =>
        props.marginTop &&
        `
        margin-top: ${props.theme[props.marginTop]};
    `};
    ${props =>
        props.marginBottom &&
        `
        margin-bottom: ${props.theme[props.marginBottom]};
    `};
`

WithMargin.propTypes = {
    margin: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    marginRight: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    marginLeft: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    marginTop: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    marginBottom: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
}
WithMargin.displayName = "WithMargin"

export default WithMargin



// WEBPACK FOOTER //
// ./src/ui/utils/WithMargin.js